import { agroApi } from "../../../redux/api/api";
import { ApiResponse, KurultaiResponse, KurultaiAllDataResponse } from "./types";

interface FilterRequest {
  page: number;
  size: number;
  regionIds: number[];
  executionStatusIds?: number[];
  assemblyDateFrom?: string;
  assemblyDateTo?: string;
}

export const kurultaiApi = agroApi.injectEndpoints({
  endpoints: (build) => ({
    getKurultaiData: build.mutation<ApiResponse<KurultaiResponse>, void>({
      query: () => ({
        url: '/kurultai-register/analytical-data/general',
        method: 'POST',
        body: {}
      }),
    }),
    getKurultaiAreaData: build.mutation<ApiResponse<KurultaiResponse>, FilterRequest>({
      query: (filter) => ({
        url: '/kurultai-register/analytical-data/area',
        method: 'POST',
        body: filter
      }),
    }),
    getAllData: build.mutation<ApiResponse<KurultaiAllDataResponse>, FilterRequest>({
      query: (filter) => ({
        url: '/kurultai-register/get-all/map',
        method: 'POST',
        body: filter
      }),
    }),
  }),
});

export const { 
  useGetKurultaiDataMutation,
  useGetKurultaiAreaDataMutation,
  useGetAllDataMutation
} = kurultaiApi;